import React, { useState } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@frontend/shadcn/components/ui/avatar';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import { isValidHttpUrl } from '@frontend/applications/ProductFulfillmentApp/NoCatalogueProductSelection/utils/isValidHttpsUrl';
import { RecentPostsNoBorderIcon } from '../../../../components/icons/recent-posts-no-border-icon';
import { VerifiedBadgeIcon } from '../../../../components/icons/verified-badge-icon';
import { CreatorAvatarHeaderComponentProps } from './hooks';

export const CreatorAvatarHeader: React.FC<CreatorAvatarHeaderComponentProps> = ({
  profilePictureUrl,
  username,
  isVerified,
  isLoading,
  originalCreator: _originalCreator,
  onReturnToOriginalCreator: _onReturnToOriginalCreator,
}) => {
  const [imageError, setImageError] = useState(false);
  const hasValidProfilePicture = profilePictureUrl && profilePictureUrl !== '' && isValidHttpUrl(profilePictureUrl) && !imageError;

  if (isLoading) {
    return (
      <div className="flex items-center justify-between px-4 py-2 bg-gray-200" role="status" aria-label="Loading creator information">
        <div className="flex items-center space-x-1">
          <Skeleton className="h-8 w-8 rounded-full" aria-hidden="true" />
          <div className="flex flex-col">
            <div className="flex items-center gap-1">
              <Skeleton className="h-4 w-[120px]" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-gray-200" role="article" aria-label={`Creator profile for ${username}`}>
      <div className="flex items-center space-x-1">
        <Avatar className="h-8 w-8 border" role="img" aria-label={`Profile picture of ${username}`}>
          <AvatarImage
            src={hasValidProfilePicture ? profilePictureUrl : undefined}
            alt={`${username}'s profile picture`}
            onError={() => setImageError(true)}
          />
          <AvatarFallback className="flex items-center justify-center h-full w-full bg-gray-300" aria-hidden="true">
            <RecentPostsNoBorderIcon width={20} height={20} />
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <div className="flex items-center gap-1">
            <a
              href={`https://instagram.com/${username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="overflow-hidden text-ellipsis whitespace-nowrap hover:underline mb-0 text-primary"
              onClick={(e) => e.stopPropagation()}
              aria-label={`Username: ${username}`}
            >
              {username ? `@${username}` : ''}
            </a>
            {isVerified && (
              <VerifiedBadgeIcon className="h-4 w-4" role="img" aria-label="Verified account" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
